import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Highlight')(
  css({
    mb: 'm',
    '& li': {
      listStyleType: '"• "',
      letterSpacing: '0.5px',
      lineHeight: '22px',
      fontSize: '12px',
      pb: 'xxs',
      '-webkit-text-size-adjust': 'none',
    },
  }),
);

themeStyles.addBaseStyles('HighlightModalTitleWrapper')(
  css({
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    alignItems: ['flex-start', 'flex-start', 'baseline'],
    mt: '-32px',
    gap: ['xs', 'xs', 'm'],
    px: 's',
  }),
);

themeStyles.addBaseStyles('LearnMoreWrapper')(
  css({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: '14px',
    '&>div': {
      mb: 'zero',
    },
  }),
);

themeStyles.addBaseStyles('Title')(
  css({
    fontSize: ['16px', '16px', '24px'],
    lineHeight: ['20px', '20px', '28px'],
    fontFamily: 'bold',
  }),
);

themeStyles.addBaseStyles('HighlightTitle')(
  css({
    fontFamily: 'bold',
  }),
);

export default themeStyles;
